/*
 * LanguageSelect
 * @module components
 * @flow weak
 */

import { compose, withHandlers } from 'recompose';
import { graphql } from 'react-apollo';

import { withSettings } from '~/features/App/Settings';
import { LOGGED_IN_USER, UPDATE_LOCALE } from '~/gql';

import { LanguageSelect as LGS } from './LanguageSelect';

const withLocaleMutation = graphql(UPDATE_LOCALE, {
  name: 'updateLocale',
});

const enhance = compose(
  withLocaleMutation,
  withSettings,
  withHandlers({
    onLanguageSelect: ({ locale, updateLocale }) => ({ value }) => {
      if (locale === value) {
        return;
      }

      updateLocale({
        variables: { locale: value },
        refetchQueries: [
          {
            query: LOGGED_IN_USER,
            variables: { includeIdToken: true },
          },
        ],
      });
    },
  }),
);

export const LanguageSelect = enhance(LGS);
